/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SwiperGameHeader.vue?vue&type=template&id=3926c966"
import script from "./SwiperGameHeader.vue?vue&type=script&lang=js"
export * from "./SwiperGameHeader.vue?vue&type=script&lang=js"
import style0 from "./SwiperGameHeader.vue?vue&type=style&index=0&id=3926c966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports